import React, { useState, useEffect, useRef } from "react";
import { Box, Grid, TextField } from "@mui/material";
import SliderAuth from "../../../components/SliderAuth/SliderAuth";
import Loader from "../../../components/Loader/Loader";
import { useNavigate } from "react-router-dom";
import { images } from "../../../config/images";
import { Button } from "../../../components/Button/button";
import PrivacyPolicy from "../../../components/Privacy/Privacy";
import { getCaptcha, verifyCaptcha, verifyuser } from "../service";
import CachedIcon from "@mui/icons-material/Cached";
import {
  notifyError,
  notifySuccess,
} from "../../../components/ToastNotification/ToastNotification";
import "./signin.css";
import ReCAPTCHA from "react-google-recaptcha";

const LoginWithUserNameOrPassword = ({
  setEmail,
  setMobileNo,
  onNextClick,
}) => {
  const navigate = useNavigate();

  const [isLoading, setLoading] = useState(false);
  const [captchaValue, setCaptchaValue] = useState("");
  const [captchaImage, setCaptchaImage] = useState("");
  const [captchaToken, setCaptchaToken] = useState("");
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);

  const [formvalues, setFormvalue] = React.useState({
    username_mobno: "",
  });
  const recaptchaRef = useRef(null);
  const [isRecaptchaValid, setRecaptchaValid] = useState(false);
  const SITE_KEY = "6LfSHygrAAAAAFFC47tkiElm0Km25wN-d3q1IB1W";

  const [isEmailValid, setEmailValid] = useState(false);
  const [isMobileValid, setMobileValid] = useState(false);
  const handleChange = (e) => {
    setFormvalue({ ...formvalues, [e.target.name]: e.target.value });
  };
  // Update validity when form values change
  useEffect(() => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const mobileRegex = /^[6-9]\d{9}$/;

    if (emailRegex.test(formvalues.username_mobno)) {
      setEmailValid(true);
      setMobileValid(false);
    } else if (mobileRegex.test(formvalues.username_mobno)) {
      setMobileValid(true);
      setEmailValid(false);
    } else {
      setEmailValid(false);
      setMobileValid(false);
    }
  }, [formvalues.username_mobno]);

  const handleLoginWithOtp = async () => {
    if (!captchaValue) {
      notifyError("Captcha is required");
      return;
    }

    // Always verify captcha
    try {
      const data = {
        captcha_code: captchaValue,
        token: captchaToken,
      };
      const captchaResponse = await verifyCaptcha(data);
      const success = captchaResponse.data.success;
      if (!success) {
        notifyError("Invalid captcha");
        await handleReloadCaptcha();
        setCaptchaValue("");
        return;
      }
    } catch (error) {
      notifyError(error.response?.data?.message || "Failed to verify captcha");
      await handleReloadCaptcha();
      setCaptchaValue("");
      return;
    }

    // Proceed with OTP logic
    try {
      const params = { mobile_no: formvalues.username_mobno };
      const resp = await verifyuser(params);
      if (resp.data.success) {
        setMobileNo(formvalues.username_mobno);
        onNextClick("loginWithOtp");
        notifySuccess(resp.data.message);
      } else {
        notifyError(resp.data.message);
      }
    } catch (error) {
      console.error("Error verifying user:", error);
      notifyError(error.response?.data?.message || "An error occurred");
    } finally {
      await handleReloadCaptcha();
      setCaptchaValue("");
    }
  };

  const handleLoginWithPassword = async () => {
    if (!captchaValue) {
      notifyError("Captcha is required");
      return;
    }

    // Always verify captcha
    try {
      const data = {
        captcha_code: captchaValue,
        token: captchaToken,
      };
      const captchaResponse = await verifyCaptcha(data);
      const success = captchaResponse.data.success;
      if (!success) {
        notifyError("Invalid captcha");
        await handleReloadCaptcha();
        setCaptchaValue("");
        return;
      }
    } catch (error) {
      notifyError(error.response?.data?.message || "Failed to verify captcha");
      await handleReloadCaptcha();
      setCaptchaValue("");
      return;
    }

    // Proceed with Password logic
    try {
      const params = { username: formvalues.username_mobno };
      const resp = await verifyuser(params);
      if (resp.data.success) {
        setEmail(formvalues.username_mobno);
        onNextClick("loginWithPassword");
        notifySuccess(resp.data.message);
      } else {
        notifyError(resp.data.message);
      }
    } catch (error) {
      console.error("Error verifying user:", error);
      notifyError(error.response?.data?.message || "An error occurred");
    } finally {
      await handleReloadCaptcha();
      setCaptchaValue("");
    }
  };

  useEffect(() => {
    const savedUser =
      localStorage.getItem("user") || sessionStorage.getItem("user");

    if (savedUser) {
      const userData = JSON.parse(savedUser);
      console.log("savedUser", userData.email);

      setFormvalue((prevState) => ({
        ...prevState,
        username_mobno: userData.email || "", // Set the saved email, or an empty string if not present
      }));
    }
  }, []);

  const handleUnlockAccount = () => {
    navigate("/unlock-account");
  };

  const handleRecaptchaChange = (value) => {
    if (value) setRecaptchaValid(true);
    else setRecaptchaValid(false);
  };

  const handleReloadCaptcha = async () => {
    try {
      const response = await getCaptcha();
      const data = await response.data.payload;
      setCaptchaImage(data.image);
      setCaptchaValue("");
      setCaptchaToken(data.token);
      setIsCaptchaVerified(false); // Reset verification status when reloading captcha
    } catch (error) {
      console.error("Error loading captcha:", error);
      notifyError("Failed to load captcha");
    }
  };
  useEffect(() => {
    handleReloadCaptcha();
  }, []);

  return (
    <>
      <Grid container className="main-container">
        {/* Left side - Slider */}
        <SliderAuth />

        {/* Right side - Login Form */}
        <Grid item size={{ xs: 12, md: 5, lg: 4 }} className="signIn-form-wrap">
          <div className="pb-2">
            <img src={images.logo} alt="" className="signIn-logo" />
          </div>
          <h3 className="text-center singIn-title">Welcome</h3>
          <TextField
            id="filled-basic"
            name="username_mobno"
            label="Username/ Mobile No"
            value={formvalues.username_mobno}
            onChange={handleChange}
            variant="filled"
            validators={["required"]}
            errorMessages={["This field is required"]}
            className="username-input"
            slotProps={{
              inputLabel: {
                className: "input-label",
              },
            }}
          />
          {/* <div className="recaptcha-container mt-4">
            <ReCAPTCHA
              sitekey={SITE_KEY}
              ref={recaptchaRef}
              onChange={handleRecaptchaChange}
            />
          </div> */}

          <div className="captcha-container">
            <TextField
              id="captcha-input"
              name="captcha"
              label="Enter Captcha"
              value={captchaValue}
              onChange={(e) => {
                const value = e.target.value;
                if (/^[a-zA-Z0-9]*$/.test(value) && value.length <= 6) {
                  setCaptchaValue(value);
                }
              }}
              
              variant="filled"
              className="captcha-input"
            />
              <button
                className="reload-captcha-btn border-btn"
                onClick={handleReloadCaptcha}
              >
                <CachedIcon />
              </button>
              <img src={captchaImage} alt="Captcha" className="captcha-image" />
          </div>

          <div className="welcome-button">
            <Button
              classname={isMobileValid ? "custom-button" : "border-btn"}
              title="Login With OTP"
              onClick={() => {
                handleLoginWithOtp();
              }}
              className={`otp-button ${!isMobileValid ? "disabled" : ""}`}
              disabled={!isMobileValid}
            />
            <Button
              classname={isEmailValid ? "custom-button" : "border-btn"}
              title="Login With Password"
              onClick={() => {
                handleLoginWithPassword();
              }}
              className={`password-button ${!isEmailValid ? "disabled" : ""}`}
              disabled={!isEmailValid}
            />
          </div>

          <div className="account-help-links">
            <div className="link-item">
              <p onClick={handleUnlockAccount}>Unlock account?</p>
            </div>
          </div>

          <PrivacyPolicy />
        </Grid>
      </Grid>
      {isLoading && <Loader />}
    </>
  );
};

export default LoginWithUserNameOrPassword;
